"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var ExtrasContinueButton_1 = require("./buttons/ExtrasContinueButton");
var FinanceSection_1 = require("./financeSection/FinanceSection");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var Loader_1 = require("../../../../common/components/presentation/Loader/Loader");
var extrasStyles_1 = require("./extrasStyles");
var Routes_1 = require("../../../../common/enum/Routes");
var react_router_1 = require("react-router");
var ExpressionsOfInterest_1 = require("../../../commonSteps/extras/components/expressionsOfInterest/ExpressionsOfInterest");
var Extras = function () {
    var _a;
    var history = react_router_1.useHistory();
    var _b = useCheckoutContext_1.default(), deal = _b.deal, loading = _b.loading, error = _b.error;
    var hasFinance = react_1.useMemo(function () { var _a, _b; return ((_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.finance) === null || _b === void 0 ? void 0 : _b.type) === globalTypes_1.FinanceFormType.finance; }, [deal]);
    var redirectUnavailableDeal = react_1.useCallback(function () { return history.replace(Routes_1.Routes.DEAL_UNAVAILABLE, {}); }, []);
    var dealExpressionsOfInterest = react_1.useMemo(function () { var _a; return (((_a = deal) === null || _a === void 0 ? void 0 : _a.expressionsOfInterest) ? deal.expressionsOfInterest.map(function (item) { return item.code; }) : []); }, [deal]);
    var styles = extrasStyles_1.default();
    react_1.useEffect(function () {
        if (error) {
            redirectUnavailableDeal();
        }
    }, [error]);
    if (loading) {
        return <Loader_1.default />;
    }
    return (<core_1.Box className={styles.container} data-test={'checkout:extras:root'}>
      {!hasFinance && <FinanceSection_1.default startConfigurationSourceUrl={(_a = deal) === null || _a === void 0 ? void 0 : _a.car.startConfigurationSourceUrl}/>}
      <ExpressionsOfInterest_1.default dealExpressionsOfInterest={dealExpressionsOfInterest}/>
      <ExtrasContinueButton_1.default dealExpressionsOfInterest={dealExpressionsOfInterest}/>
    </core_1.Box>);
};
exports.default = Extras;
